import "./BarCode.css";

import { useEffect, useRef, useState } from "react";
import JsBarcode from "jsbarcode";

//AntDesign Imports
import { DownloadOutlined } from "@ant-design/icons";
import { Button, Radio } from "antd";

const BarCode = ({ text, setBarCodeText, showActions, info }) => {
  const barcodeRef = useRef(null);
  const [orientation, setOrientation] = useState("landscape"); // 'portrait' or 'landscape'

  const handleDownload = () => {
    if (showActions) {
      const svgElement = barcodeRef.current;
      const serializer = new XMLSerializer();
      const source = serializer.serializeToString(svgElement);

      // Create a hidden iframe
      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";

      // Append iframe to document body
      document.body.appendChild(iframe);
      const doc = iframe.contentDocument || iframe.contentWindow.document;

      // Determine page size based on orientation
      const pageSize = orientation === "portrait" ? "3in 5in" : "5in 3in";

      // Write printable content to iframe document
      doc.open();
      doc.write(`
    <html>
      <head>
      <title>Stack Enable</title>
        <style>
          @page {
            size: ${pageSize};
            margin: 0;
          }
          
          body { 
            margin: 0;
            padding: 0;
            visibility: hidden;
          }
          
          @media print {
            body {
              visibility: visible;
            }
            
            .barcode { 
              visibility: visible;
              width: ${orientation === "portrait" ? "3in" : "5in"};
              height: ${orientation === "portrait" ? "5in" : "3in"};
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              page-break-inside: avoid;
              margin: 0;
              padding: 0.25in;
              box-sizing: border-box;
            }
            
            .barcode svg {
              max-width: 100%;
              max-height: 100%;
              width: auto;
              height: auto;
              object-fit: contain;
            }
          }
        </style>
      </head>
      <body>
        <div class="barcode">${source}</div>
      </body>
    </html>
  `);
      doc.close();

      // Wait for iframe to load
      iframe.onload = () => {
        // Print the iframe content
        iframe.contentWindow.print();
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      };
    }
  };

  useEffect(() => {
    if (barcodeRef.current && text) {
      // Adjust barcode dimensions based on orientation
      const barcodeWidth = orientation === "portrait" ? 1.5 : 2.5;
      const barcodeHeight = orientation === "portrait" ? 120 : 80;

      JsBarcode(barcodeRef.current, text, {
        width: barcodeWidth,
        height: barcodeHeight,
        lineColor: "#000",
        format: "CODE128",
        displayValue: true,
        margin: 10,
        fontSize: 20,
        background: "#fff",
        textAlign: "center",
        fontOptions: "bold",
        font: "monospace",
        text: info || text,
      });
      
      // Adjust SVG viewBox to prevent text cutoff
      const svg = barcodeRef.current;
      const boundingBox = svg.getBBox();
      const padding = 20;
      svg.setAttribute("viewBox", `0 0 ${boundingBox.width + padding} ${boundingBox.height + padding}`);
      svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
    }
  }, [text, info, orientation]);

  return (
    <div className="barcode-wrapper">
      <div className="barcode">
        <svg ref={barcodeRef}></svg>
      </div>
      {showActions && (
        <div style={{ marginBottom: "5px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Radio.Group 
            value={orientation} 
            onChange={(e) => setOrientation(e.target.value)}
            buttonStyle="solid"
          >
            <Radio.Button value="landscape">Landscape</Radio.Button>
            <Radio.Button value="portrait">Portrait</Radio.Button>
          </Radio.Group>
          
          <div className="barcode-button">
            <Button 
              type="primary" 
              style={{ width: "25px", height: "25px" }} 
              icon={<DownloadOutlined />} 
              size="medium" 
              onClick={handleDownload}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BarCode;